import React, { useEffect, useState, useMemo } from "react";
import dayjs from "dayjs";
import BreadCrumsHeader from "../../common/BreadCrums";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Checkbox from "../../common/Checkbox";
import SwitchStatus from "../../common/Status";
import Pagination from "../../common/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/Loader";
import {
  getAllTargets,
  getFundraisers,
  toggleFundraiserStatus,
  deleteFundraiserById,
  approveOrRejectFundraiser,
} from "../../../services/fundraiserService";
import RejectOfferPopup from "../../common/RejectOfferPopup";
import crossIcon from "../../../Assets/Icons/cross.svg";
import closeIcon from "../../../Assets/Icons/popupCloseIcon.svg";
import whiteTick from "../../../Assets/Icons/White Tick.svg";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";
import { ReactComponent as UncheckedIcon } from "../../../Assets/Icons/uncheckedWhiteBox.svg";
import { ReactComponent as UncheckedGreyIcon } from "../../../Assets/Icons/unCheckedGreyIcon.svg";
import { ReactComponent as ApprovedIcon } from "../../../Assets/Icons/approveIcon.svg";
import { ReactComponent as DeclinedIcon } from "../../../Assets/Icons/declinedIcon.svg";
import { ReactComponent as PendingIcon } from "../../../Assets/Icons/pendingIcon.svg";
import "./fundraiserList.scss";
import SearchBar from "../../common/SearchBar";
import { Dropdown } from "antd";
import { DatePicker } from "antd";
import FilterButton from "../../common/FilterButton";

import toast from "../../../utils/toast";
import FilterPanel from "../../common/FilterPanel";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { ReactComponent as FiltersIcon } from "../../../Assets/Icons/filtersIcon.svg";
import debounce from "lodash.debounce";
import { getFundraiserById } from "../../../services/fundraiserService";
import DetailsModal from "../../common/DetailsModal";
import TableEmptyState from "../../common/TableEmptyState";
import PopupContent from "./PopupContent";
import CancelPopup from "../../common/CancelPopup";
import ActiveFilterBar from "../../common/ActiveFilterBar";
import { Drawer as MuiDrawer } from "@mui/material";
import deleteImg from "../../../Assets/Icons/deleteIcon.svg";

const { RangePicker } = DatePicker;

const FundraiserListDataTable = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.fundraiserReducer?.loading);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setCount] = useState(0);
  const [statusToggled, setStatusToggled] = useState(false);
  const [selected, setSelected] = useState([]);
  const [showActionModal, setShowActionModal] = useState(false);
  const [customDate, setCustomDate] = useState([null, null]);

  const DURATION_MAP = {
    "Today": "DAY",
    "This Week": "WEEK",
    "This Month": "MONTH",
    "This Year": "YEAR",
    "Custom Date": "CUSTOM",
  };
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [filterParams, setFilterParams] = useState({
    status: null,
    duration: null,
    startDate: null,
    endDate: null,
  });
  const [fundraiserDetails, setFundraiserDetails] = useState({});
  const [selectedYear, setSelectedYear] = useState("2025");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [fundraiserToDelete, setFundraiserToDelete] = useState(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [searching, setSearching] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [fullFundraisersList, setFullFundraisersList] = useState([]);
  const [displayedFundraisers, setDisplayedFundraisers] = useState([]);
  const [manualSortMap, setManualSortMap] = useState(() => {
    try {
      const saved = localStorage.getItem('fundraiserManualSortMap');
      return saved ? JSON.parse(saved) : {};
    } catch { return {}; }
  });

  // Persist manual sort map to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('fundraiserManualSortMap', JSON.stringify(manualSortMap));
  }, [manualSortMap]);

  const [filterData, setFilterData] = useState([
    {
      id: "status",
      title: "Status",
      options: ["Approved", "Declined", "Pending"],
      defaultValue: "",
      multiSelect: false,
      valueMap: {
        "Approved": "approved",
        "Declined": "declined",
        "Pending": "pending",
      }
    },
    {
      id: "duration",
      title: "Time Period",
      options: ["Today", "This Week", "This Month", "This Year", "Custom Date"],
      defaultValue: "",
      multiSelect: false,
      valueMap: DURATION_MAP,
      customContent: (selected, filterParams) => {
        console.log("Custom Date selected value:", selected);
        return selected === "Custom Date" ? (
          <div className="mt-3 flex flex-col gap-2" style={{ pointerEvents: 'auto', zIndex: 10000 }}>
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">Start Date</label>
              <DatePicker
                value={customDate?.[0]}
                onChange={(date) => {
                  console.log("Start date changed:", date);
                  const newDates = [date, customDate?.[1]];
                  setCustomDate(newDates);
                }}
                onClick={(e) => {
                  console.log("DatePicker clicked!", e);
                }}
                style={{ width: '100%', pointerEvents: 'auto' }}
                className="custom-date-picker"
                placeholder="Select Start Date"
                format="YYYY-MM-DD"
                showTime={false}
                allowClear={true}
                getPopupContainer={(trigger) => trigger.parentNode}
                popupClassName="date-picker-popup"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">End Date</label>
              <DatePicker
                value={customDate?.[1]}
                onChange={(date) => {
                  console.log("End date changed:", date);
                  const newDates = [customDate?.[0], date];
                  setCustomDate(newDates);
                }}
                onClick={(e) => {
                  console.log("DatePicker clicked!", e);
                }}
                style={{ width: '100%', pointerEvents: 'auto' }}
                className="custom-date-picker"
                placeholder="Select End Date"
                format="YYYY-MM-DD"
                showTime={false}
                allowClear={true}
                getPopupContainer={(trigger) => trigger.parentNode}
                popupClassName="date-picker-popup"
              />
            </div>
          </div>
        ) : null;
      }
    },
  ]);

  // Fix: Update filterData when customDate changes to avoid stale closures in customContent
  useEffect(() => {
    setFilterData((prevData) =>
      prevData.map((filter) => {
        if (filter.id === "duration") {
          return {
            ...filter,
            customContent: (selected, filterParams) => {
              console.log("Custom Date selected value:", selected);
              return selected === "Custom Date" ? (
                <div className="mt-3 flex flex-col gap-2" style={{ pointerEvents: 'auto', zIndex: 10000 }}>
                  <div className="flex flex-col gap-1">
                    <label className="text-[12px] font-medium text-gray-600">Start Date</label>
                    <DatePicker
                      value={customDate?.[0]}
                      onChange={(date) => {
                        console.log("Start date changed:", date);
                        const newDates = [date, customDate?.[1]];
                        setCustomDate(newDates);
                      }}
                      onClick={(e) => {
                        console.log("DatePicker clicked!", e);
                      }}
                      style={{ width: '100%', pointerEvents: 'auto' }}
                      className="custom-date-picker"
                      placeholder="Select Start Date"
                      format="YYYY-MM-DD"
                      showTime={false}
                      allowClear={true}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName="date-picker-popup"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="text-[12px] font-medium text-gray-600">End Date</label>
                    <DatePicker
                      value={customDate?.[1]}
                      onChange={(date) => {
                        console.log("End date changed:", date);
                        const newDates = [customDate?.[0], date];
                        setCustomDate(newDates);
                      }}
                      onClick={(e) => {
                        console.log("DatePicker clicked!", e);
                      }}
                      style={{ width: '100%', pointerEvents: 'auto' }}
                      className="custom-date-picker"
                      placeholder="Select End Date"
                      format="YYYY-MM-DD"
                      showTime={false}
                      allowClear={true}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName="date-picker-popup"
                    />
                  </div>
                </div>
              ) : null;
            }
          };
        }
        return filter;
      })
    );
  }, [customDate]);

  // Create initial state from filter data
  const createInitialState = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.multiSelect) {
        // For multi-select, initialize as array
        acc[filter.id] = Array.isArray(filter.defaultValue)
          ? filter.defaultValue
          : [];
      } else {
        // For single select, initialize as single value
        acc[filter.id] = filter.defaultValue;
      }
      return acc;
    }, {});
  };

  // Initialize selections with the initial state
  const [selections, setSelections] = useState(createInitialState(filterData));

  const handleSelectionChange = (filterId, value) => {
    setSelections((prev) => ({
      ...prev,
      [filterId]: value,
    }));
  };

  // Removed old handleReset


  const getFundraisersData = async (silent = false) => {
    if (silent) setSearching(true);
    const params = {
      limit: 1000,
      status: filterParams.status?.toLowerCase() || null,
      duration: filterParams.duration?.toLowerCase() || null,
      startDate: filterParams.startDate || null,
      endDate: filterParams.endDate || null,
      silent: silent,
    };

    Object.keys(params).forEach((key) =>
      params[key] === null ? delete params[key] : {}
    );

    try {
      const response = await dispatch(getFundraisers(params))?.unwrap();
      if (response?.success) {
        setFullFundraisersList(response?.data || []);
      }
    } finally {
      setSearching(false);
    }
  };

  const updatePageSlice = (data, page) => {
    if (!data) return;
    const startIndex = (page - 1) * 10;
    const endIndex = startIndex + 10;
    setDisplayedFundraisers(data.slice(startIndex, endIndex));
  };

  // 1. Initial/Filter load
  useEffect(() => {
    getFundraisersData();
  }, [filterParams, statusToggled]);

  // 2. Logic to filter and slice data for display
  useEffect(() => {
    if (!fullFundraisersList) return;

    let filtered = [...fullFundraisersList];

    // Search Filter
    if (searchQuery.trim()) {
      const term = searchQuery.toLowerCase().trim();
      filtered = filtered.filter((fundraiser) => {
        const name = (fundraiser?.user?.name || fundraiser?.name || fundraiser?.businessName || "").toLowerCase();
        const email = (fundraiser?.user?.email || fundraiser?.email || "").toLowerCase();
        const contact = (fundraiser?.contactPersonNumber || fundraiser?.phone || "").toLowerCase();
        const contactPerson = (fundraiser?.contactPersonName || "").toLowerCase();

        return (
          name.includes(term) ||
          email.includes(term) ||
          contact.includes(term) ||
          contactPerson.includes(term)
        );
      });
    }

    // Date Filter (Local)
    if (filterParams.duration && filterParams.duration !== "CUSTOM") {
      let start = null;
      if (filterParams.duration === "DAY") {
        start = dayjs().startOf('day');
      } else if (filterParams.duration === "WEEK") {
        start = dayjs().startOf('week');
      } else if (filterParams.duration === "MONTH") {
        start = dayjs().startOf('month');
      } else if (filterParams.duration === "YEAR") {
        start = dayjs().startOf('year');
      }

      if (start) {
        filtered = filtered.filter((fundraiser) => {
          const createdAt = fundraiser?.createdAt || fundraiser?.created_at;
          if (!createdAt) return false;
          const joinedDate = dayjs(createdAt);
          return joinedDate.isAfter(start) || joinedDate.isSame(start);
        });
      }
    }

    if (filterParams.duration === "CUSTOM" && (filterParams.startDate || filterParams.endDate)) {
      const start = filterParams.startDate ? dayjs(filterParams.startDate).startOf('day') : null;
      const end = filterParams.endDate ? dayjs(filterParams.endDate).endOf('day') : null;

      filtered = filtered.filter((fundraiser) => {
        const createdAt = fundraiser?.createdAt || fundraiser?.created_at;
        if (!createdAt) return false;

        const joinedDate = dayjs(createdAt);
        if (!joinedDate.isValid()) return false;

        let matches = true;
        if (start) matches = matches && (joinedDate.isAfter(start) || joinedDate.isSame(start));
        if (end) matches = matches && (joinedDate.isBefore(end) || joinedDate.isSame(end));
        return matches;
      });
    }

    // Default Sort Priority:
    // 1. Manual status changes (client-side timestamp) - Highest priority
    // 2. updatedAt (server-side status change) - Second priority
    // 3. createdAt (join date) - Final priority
    filtered.sort((a, b) => {
      const idA = a._id || a.id;
      const idB = b._id || b.id;

      const manualA = manualSortMap[String(idA)] || 0;
      const manualB = manualSortMap[String(idB)] || 0;

      if (manualA !== manualB) {
        return manualB - manualA; // Sort by most recent manual change first
      }

      // Fallback to server dates
      const dateA = dayjs(a?.updatedAt || a?.updated_at || a?.createdAt || a?.created_at || a?.notifiedAt || 0);
      const dateB = dayjs(b?.updatedAt || b?.updated_at || b?.createdAt || b?.created_at || b?.notifiedAt || 0);
      
      return dateB.diff(dateA); // Sort by most recent date first
    });

    setCount(filtered.length);
    setTotalPages(Math.ceil(filtered.length / 10) || 1);

    updatePageSlice(filtered, currentPage);
  }, [searchQuery, fullFundraisersList, filterParams, currentPage, manualSortMap]);



  const items = [
    {
      title: "Fundraisers",
    },
    {
      title: "Fundraiser List",
    },
  ];

  const columns = [
    {
      name: "",
      width: "40px",
    },
    {
      name: "No.",
    },
    {
      name: "Name",
    },
    {
      name: "Date Joined",
    },
    {
      name: "Email",
    },
    {
      name: "Contact",
    },
    {
      name: "Balance",
    },
    {
      name: "Status",
    },
    {
      name: "Actions",
    },
  ];

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // Scroll to top of fundraiser list when changing pages
    const container = document.getElementById('fundraiser-list-container');
    if (container) {
      container.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback to window scroll
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Allow selecting all fundraisers (any status) to enable moving Approved/Declined back to Pending
  const getSelectableFundraisers = () => {
    return fullFundraisersList || [];
  };

  const handleSelectAll = () => {
    const selectableFundraisers = getSelectableFundraisers();

    if (
      selectableFundraisers.length > 0 &&
      selected.length === selectableFundraisers.length
    ) {
      setSelected([]);
    } else {
      const newSelected = selectableFundraisers.map(
        (fundraiser) => fundraiser._id
      );
      setSelected(newSelected);
    }
  };

  const handleSelectOne = (event, id, status) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else {
      newSelected = selected.filter((selectedId) => selectedId !== id);
    }

    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // All statuses selectable
  const isSelectable = (status) => {
    return true;
  };

  const handleBulkApprove = async () => {
    try {
      const payload = { ids: selected, status: "approved" };
      const res = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (res?.success === true) {
        const timestamp = Date.now();
        const newSortMap = { ...manualSortMap };
        selected.forEach(id => { newSortMap[String(id)] = timestamp; });
        setManualSortMap(newSortMap);
        setFullFundraisersList(prev => prev.map(f => selected.includes(f._id || f.id) ? { ...f, status: "approved" } : f));
        setSelected([]);
        setShowActionModal(false);
        setStatusToggled(!statusToggled);
        try { toast.success("Fundraiser(s) approved successfully"); } catch (_) { }
      }
    } catch (_) { }
  };

  const handleBulkDecline = async () => {
    // Open modal to capture reason, then submit via submitBulkDecline
    setBulkDeclineReason("");
    setShowBulkDeclineModal(true);
  };

  // Move selected fundraisers to pending
  const handleBulkPending = async () => {
    try {
      const payload = { ids: selected, status: "pending" };
      const res = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (res?.success === true) {
        const timestamp = Date.now();
        const newSortMap = { ...manualSortMap };
        selected.forEach(id => { newSortMap[String(id)] = timestamp; });
        setManualSortMap(newSortMap);
        setFullFundraisersList(prev => prev.map(f => selected.includes(f._id || f.id) ? { ...f, status: "pending" } : f));
        setSelected([]);
        setShowActionModal(false);
        setStatusToggled(!statusToggled);
        try { toast.success("Moved to pending"); } catch (_) { }
      }
    } catch (_) { }
  };

  // --- Bulk Decline Modal State/Handlers ---
  const [showBulkDeclineModal, setShowBulkDeclineModal] = useState(false);
  const [bulkDeclineReason, setBulkDeclineReason] = useState("");

  const closeBulkDeclineModal = () => {
    setShowBulkDeclineModal(false);
    setBulkDeclineReason("");
  };

  const submitBulkDecline = async () => {
    const trimmed = (bulkDeclineReason || "").trim();
    if (!trimmed || selected.length === 0) return;
    try {
      const payload = { ids: selected, status: "declined", reason: trimmed };
      const res = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (res?.success) {
        const timestamp = Date.now();
        const newSortMap = { ...manualSortMap };
        selected.forEach(id => { newSortMap[String(id)] = timestamp; });
        setManualSortMap(newSortMap);
        setFullFundraisersList(prev => prev.map(f => selected.includes(f._id || f.id) ? { ...f, status: "declined" } : f));
        setSelected([]);
        setShowActionModal(false);
        setStatusToggled(!statusToggled);
        closeBulkDeclineModal();
        try { toast.success("Fundraiser(s) declined successfully"); } catch (_) { }
      }
    } catch (_) { }
  };

  useEffect(() => {
    if (selected.length > 0) {
      setShowActionModal(true);
    } else {
      setShowActionModal(false);
    }
  }, [selected]);

  const activeFilterChips = useMemo(() => {
    const chips = [];
    Object.entries(filterParams).forEach(([key, value]) => {
      if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) return;
      if (value === "") return;
      
      const filter = filterData.find((f) => f.id === key);
      if (!filter) return;

      if (filter.multiSelect && Array.isArray(value)) {
        value.forEach((val) => {
          const displayLabel = Object.keys(filter.valueMap || {}).find(k => filter.valueMap[k] === val) || val;
          chips.push({ id: key, value: val, label: `${displayLabel}` });
        });
      } else {
        const displayLabel = Object.keys(filter.valueMap || {}).find(k => filter.valueMap[k] === value) || value;
        chips.push({ id: key, value: value, label: `${displayLabel}` });
      }
    });

    // Special handling for custom date range label
    if (filterParams.duration === "Custom Date" && (filterParams.startDate || filterParams.endDate)) {
      const dChip = chips.find(c => c.id === 'duration');
      if (dChip) {
        const start = filterParams.startDate || "...";
        const end = filterParams.endDate || "...";
        dChip.label = `${start} to ${end}`;
      }
    }

    return chips;
  }, [filterParams, filterData]);

  const activeCount = activeFilterChips.length;

  const applyFilters = (sels) => {
    const mappedFilterParams = {
      status: null,
      duration: null,
      startDate: null,
      endDate: null,
    };

    filterData.forEach((filter) => {
      const selectedValue = sels[filter.id];
      if (
        selectedValue !== null &&
        selectedValue !== undefined &&
        selectedValue !== "" &&
        !(Array.isArray(selectedValue) && selectedValue.length === 0)
      ) {
        if (filter.id === "duration" && selectedValue === "Custom Date") {
          mappedFilterParams.duration = "CUSTOM";
          if (customDate && (customDate[0] || customDate[1])) {
            mappedFilterParams.startDate = customDate[0] ? customDate[0].format("YYYY-MM-DD") : null;
            mappedFilterParams.endDate = customDate[1] ? customDate[1].format("YYYY-MM-DD") : null;
          }
        } else if (filter.valueMap) {
          mappedFilterParams[filter.id] = filter.multiSelect
            ? selectedValue.map((val) => filter.valueMap[val])
            : filter.valueMap[selectedValue];
        } else {
          mappedFilterParams[filter.id] = selectedValue;
        }
      }
    });

    setFilterParams(mappedFilterParams);
    setCurrentPage(1);
  };

  const handleApply = () => {
    applyFilters(selections);
    setOpen(false);
  };

  const handleReset = () => {
    const initialState = createInitialState(filterData);
    setSelections(initialState);
    setFilterParams({
      status: null,
      duration: null,
      startDate: null,
      endDate: null,
    });
    setCustomDate([null, null]);
    setSearchInput("");
    setSearchQuery("");
    setCurrentPage(1);
  };

  const handleRemoveFilter = (targetChip) => {
    const filter = filterData.find((f) => f.id === targetChip.id);
    if (!filter) return;

    let newValue;
    if (filter.multiSelect) {
      newValue = selections[targetChip.id].filter((v) => v !== targetChip.value);
    } else {
      newValue = null;
    }

    const newSelections = { ...selections, [targetChip.id]: newValue };
    setSelections(newSelections);
    
    if (targetChip.id === 'duration' && newValue === null) {
      setCustomDate([null, null]);
    }

    applyFilters(newSelections);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((query) => {
        setSearchQuery(query);
      }, 500),
    []
  );

  const handleSearchChange = (value) => {
    setSearchInput(value);
    setSearching(true);
    debouncedSearch(value);
  };


  const fetchFundraiserDetails = async (fundraiserId) => {
    try {
      const result = await dispatch(getFundraiserById({ id: fundraiserId, silent: true }))?.unwrap();
      if (result?.success) {
        setFundraiserDetails(prev => ({ ...prev, ...result.data }));
      }
    } catch (e) { console.error(e); }
  };

  const fetchTargets = async (fundraiserId, year) => {
    try {
      const result = await dispatch(getAllTargets({ id: fundraiserId, year, silent: true }))?.unwrap();
      if (result?.success) {
        setFundraiserDetails(prev => ({ ...prev, target: result.data }));
      }
    } catch (e) { console.error(e); }
  };

  const openPopup = async (fundraiserId) => {
    setFundraiserDetails(null);
    setIsDetailOpen(true);
    fetchFundraiserDetails(fundraiserId);
    fetchTargets(fundraiserId, selectedYear);
  };

  const closePopup = () => {
    setSelectedYear("2025");
    setFundraiserDetails(null);
    setIsDetailOpen(false);
  };

  const handleYearChange = (fundraiserId, dateString) => {
    setSelectedYear(dateString);
    fetchTargets(fundraiserId, dateString);
  };

  const handleDeleteFundraiser = (id) => {
    setFundraiserToDelete(id);
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const deletePromise = await dispatch(
        deleteFundraiserById({ id: fundraiserToDelete })
      )?.unwrap();
      if (deletePromise?.success === true) {
        setIsDetailOpen(false);
        getFundraisersData(searchQuery);
      }
    } catch (error) {
      console.error("Error deleting fundraiser:", error);
    } finally {
      setShowDeleteConfirm(false);
      setFundraiserToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
    setFundraiserToDelete(null);
  };

  const handleShowReviewModal = () => {
    setShowReviewModal(true);
  };

  const handleCloseReviewModal = () => {
    setShowReviewModal(false);
  };

  // Decline flow using themed modal and closing details first
  const [showFundraiserDecline, setShowFundraiserDecline] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [declineTargetId, setDeclineTargetId] = useState(null);

  const openDeclineModal = (fundraiserId) => {
    setIsDetailOpen(false); // hide details while decline modal is open
    setDeclineTargetId(fundraiserId);
    setDeclineReason("");
    setShowFundraiserDecline(true);
  };

  const closeDeclineModal = (success = false) => {
    setShowFundraiserDecline(false);
    setDeclineReason("");
    setDeclineTargetId(null);
    // Reopen the details modal only if it wasn't a success (cancel case)
    if (!success) {
      setIsDetailOpen(true);
    }
  };

  const submitDecline = async () => {
    const trimmed = (declineReason || "").trim();
    if (!trimmed || !declineTargetId) return;
    try {
      const payload = { ids: [declineTargetId], status: "declined", reason: trimmed };
      const resp = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (resp?.success) {
        const fundraiserId = declineTargetId;
        setManualSortMap(prev => ({ ...prev, [String(fundraiserId)]: Date.now() }));
        setFullFundraisersList(prev => prev.map(f => (f._id === fundraiserId || f.id === fundraiserId) ? { ...f, status: 'declined' } : f));
        setFundraiserDetails(prev => ({ ...(prev || {}), status: 'declined' }));
        setStatusToggled(!statusToggled);
        closeDeclineModal(true); // pass true for success
        setIsDetailOpen(false); // explicitly close detail modal
        try { toast.success("Fundraiser declined successfully"); } catch (_) { }
      }
    } catch (_) { }
  };

  const handleApproveSingle = async (fundraiserId) => {
    try {
      const payload = { ids: [fundraiserId], status: "approved" };
      const res = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (res?.success === true) {
        setManualSortMap(prev => ({ ...prev, [String(fundraiserId)]: Date.now() }));
        setFullFundraisersList(prev => prev.map(f => (f._id === fundraiserId || f.id === fundraiserId) ? { ...f, status: 'approved' } : f));
        setStatusToggled(!statusToggled);
        setIsDetailOpen(false); // Close the modal
        try { toast.success("Fundraiser approved successfully"); } catch (_) { }
      }
    } catch (_) { }
  };

  const handleReviewStatus = async (fundraiserId, newStatus) => {
    try {
      const payload = { ids: [fundraiserId], status: newStatus };
      const statusPromise = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (statusPromise?.success === true) {
        setManualSortMap(prev => ({ ...prev, [String(fundraiserId)]: Date.now() }));
        setFullFundraisersList(prev => prev.map(f => (f._id === fundraiserId || f.id === fundraiserId) ? { ...f, status: newStatus } : f));
        setStatusToggled(!statusToggled);
        setIsDetailOpen(false);
        setShowReviewModal(false);
      }
    } catch (e) {
      console.error("Error reviewing fundraiser status:", e);
    }
  };

  // Calculate count of selectable items for "Select All" checkbox
  const selectableCount = getSelectableFundraisers().length;
  const allSelectableSelected =
    selectableCount > 0 && selected.length === selectableCount;

  // Determine which bulk action buttons to show based on selected statuses
  const selectedStatuses = selected
    .map((id) => fullFundraisersList?.find((f) => (f._id === id || f.id === id))?.status)
    .filter(Boolean)
    .map((s) => s?.toLowerCase());
  const hasPendingSelected = selectedStatuses.includes("pending");
  const hasApprovedDeclinedSelected = selectedStatuses.some(status => status === "approved" || status === "declined");

  // Show approve/decline buttons only if there are pending items selected
  const showApproveDecline = selected.length > 0 && hasPendingSelected;
  // Show move to pending only if there are approved/declined items selected
  const showMoveToPending = selected.length > 0 && hasApprovedDeclinedSelected;

  return (
    <>
      {loading === true && <Loader />}
      {isDetailOpen && (
        <div style={{
          position: 'fixed',
          inset: 0,
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          animation: 'fadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1)'
        }}>
          <style>
            {`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes slideIn {
                from { transform: translateY(-20px) scale(0.95); opacity: 0; }
                to { transform: translateY(0) scale(1); opacity: 1; }
              }
            `}
          </style>
          <div style={{
            animation: 'slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <DetailsModal
              handleClose={closePopup}
              content={
                <PopupContent
                  merchantDetails={fundraiserDetails}
                  setSelectedYear={setSelectedYear}
                  selectedYear={selectedYear}
                  handleYearChange={handleYearChange}
                  onDelete={handleDeleteFundraiser}
                  onShowReviewModal={handleShowReviewModal}
                  onDecline={openDeclineModal}
                  onApprove={handleApproveSingle}
                  onStatusChange={(newStatus) => setFundraiserDetails(prev => ({ ...(prev || {}), status: newStatus }))}
                />
              }
              popupClassName="p-6 w-[335px] sm:w-[600px] md:w-[728px]"
            />
          </div>
        </div>
      )}
      {showFundraiserDecline && (
        <RejectOfferPopup
          handleClose={closeDeclineModal}
          content={"Please provide a reason for declining this fundraiser. Your reason will be emailed to the fundraiser contact."}
          popupClassName={"w-[335px] sm:w-[470px] pb-4"}
          setReason={setDeclineReason}
          handleOfferRejection={submitDecline}
          showCloseIcon={true}
        />
      )}
      {showDeleteConfirm && (
        <CancelPopup
          handleNo={handleDeleteCancel}
          handleYes={handleDeleteConfirm}
          heading="Delete Fundraiser"
          content="Are you sure you want to delete this fundraiser profile? This action cannot be undone."
          image={deleteImg}
          confirmation={false}
          popupClassName="w-[300px] sm:w-[420px] h-[224px] sm:h-[220px]"
        />
      )}
      <div className="flex flex-col sm:flex-row justify-between col-span-12 gap-4">
        <BreadCrumsHeader heading="Fundraiser List" items={items} />
      </div>

      <div className="w-full flex justify-between items-center mt-6 gap-3">
        <SearchBar
          parentDivClass="w-full sm:w-[60%] md:w-[40%] lg:w-[35%] xl:w-[30%]"
          divClassName="relative w-full"
          inputClassName="searchBar w-full p-3 pr-10 text-[14px] font-poppins font-[400] outline-none rounded-[5px] border border-[#D9D9D9] focus:border-[#00ADEF]"
          iconClassName="absolute right-[10px] top-1/2 -translate-y-1/2 w-[22px] h-[22px]"
          placeholder="Search"
          value={searchInput}
          handleChange={(e) => handleSearchChange(e.target.value)}
          onClear={() => handleSearchChange("")}
          loading={searching}
        />
        <div className="flex items-center gap-2">
          <FilterButton
            activeCount={activeCount}
            activeFilterCount={activeCount}
            isOpen={open}
            onClick={() => setOpen(true)}
          />
        </div>
        <MuiDrawer
          anchor="right"
          open={open}
          onClose={() => setOpen(false)}
          PaperProps={{
            sx: {
              width: { xs: '100%', sm: '400px' },
              padding: '0',
              height: '100%'
            }
          }}
        >
          <FilterPanel
            filterData={filterData}
            selections={selections}
            handleApply={handleApply}
            handleCancel={handleCancel}
            handleReset={handleReset}
            handleSelectionChange={handleSelectionChange}
            style={{ maxHeight: "unset" }}
          />
        </MuiDrawer>
      </div>

      <ActiveFilterBar
        chips={activeFilterChips}
        onRemove={handleRemoveFilter}
        onClearAll={handleReset}
      />

      <div id="fundraiser-list-container" className="col-span-12 mt-4 relative">
        {/* Desktop Table */}
        <TableContainer style={{ width: "100%", overflowX: "auto" }} className="hidden md:block">
          <Table
            sx={{
              minWidth: "800px",
              borderCollapse: "separate",
              borderSpacing: "0px 8px",
            }}
            aria-label="simple table"
          >
            <TableHead className="bg-[#00ADEF]">
              <TableRow
                className="h-[50px]"
                sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                <TableCell className="!border-b-0">
                  <Checkbox
                    checked={allSelectableSelected}
                    onChecked={handleSelectAll}
                    divClassName="flex items-center"
                    UncheckedIcon={UncheckedIcon}
                    checkClassName={"!w-[22px] !h-[22px]"}
                  />
                </TableCell>
                {columns.slice(1).map((column) => {
                  return (
                    <TableCell key={column.name} className="!text-[#FFFFFF]">
                      {column.name}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {displayedFundraisers && displayedFundraisers?.length > 0 &&
                displayedFundraisers?.map((fundraiser, index) => {
                  const isItemSelected = isSelected(fundraiser._id);
                  const itemSelectable = isSelectable(fundraiser.status);

                  return (
                    <TableRow
                      key={fundraiser._id}
                      className="h-[50px]"
                      sx={{
                        boxShadow: "0px 4px 4px 0px #00000040",
                        backgroundColor:
                          (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                      }}
                    >
                      <TableCell>
                        <Checkbox
                          checked={isItemSelected}
                          onChecked={(event) =>
                            handleSelectOne(
                              event,
                              fundraiser._id,
                              fundraiser.status
                            )
                          }
                          divClassName={`flex items-center ${!itemSelectable
                            ? "opacity-50 !cursor-not-allowed"
                            : ""
                            }`}
                          checkClassName={`!w-[22px] !h-[22px] ${!itemSelectable
                            ? "opacity-50 !cursor-not-allowed"
                            : ""
                            }`}
                          disabled={!itemSelectable}
                        />
                      </TableCell>
                      <TableCell>{(currentPage - 1) * 10 + index + 1}</TableCell>
                      <TableCell>{fundraiser?.user?.name || fundraiser?.name || "N/A"}</TableCell>
                      <TableCell>
                        {
                          separateDateTimeAndConvertToLocale(
                            fundraiser?.createdAt
                          )?.localDate || "N/A"
                        }
                      </TableCell>
                      <TableCell>{fundraiser?.user?.email || fundraiser?.email || "N/A"}</TableCell>
                      <TableCell>{fundraiser?.contactPersonNumber || "N/A"}</TableCell>
                      <TableCell>{"$" + (fundraiser?.balance || "0")}</TableCell>
                      <TableCell>
                        {fundraiser?.status == "pending" ? (
                          <PendingIcon />
                        ) : fundraiser?.status == "approved" ? (
                          <ApprovedIcon />
                        ) : (
                          <DeclinedIcon />
                        )}
                      </TableCell>
                      <TableCell>
                        <button
                          className={`flex justify-center items-center border rounded-[6px] p-3 h-[34px] border-[#00ADEF] text-[#00ADEF]`}
                          onClick={() => openPopup(fundraiser?._id)}
                        >
                          <span className="font-[600] text-[14px] font-poppins leading-[22px]">
                            View Details
                          </span>
                        </button>
                      </TableCell>
                    </TableRow>
                  );
                })}

              {!loading && !searching && displayedFundraisers && displayedFundraisers.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={columns.length}
                    align="center"
                    className="!border-b-0 !p-0"
                  >
                    <TableEmptyState itemName="Fundraiser" />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Mobile Card View */}
        <div className="block md:hidden space-y-4">
          {displayedFundraisers && displayedFundraisers?.length > 0 &&
            displayedFundraisers?.map((fundraiser, index) => (
              <div
                key={fundraiser._id}
                className="bg-white rounded-[10px] p-4 border border-[#E0E0E0] shadow-sm flex flex-col gap-3"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="text-[16px] font-[600] text-[#303030] font-poppins truncate max-w-[200px]">
                      {fundraiser?.user?.name || fundraiser?.name || "N/A"}
                    </h3>
                    <p className="text-[12px] font-[400] text-[#767676] font-poppins">
                      {fundraiser?.user?.email || fundraiser?.email || "N/A"}
                    </p>
                  </div>
                  <div>
                    {fundraiser?.status == "pending" ? (
                      <PendingIcon />
                    ) : fundraiser?.status == "approved" ? (
                      <ApprovedIcon />
                    ) : (
                      <DeclinedIcon />
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2 text-[13px] font-poppins text-[#303030]">
                  <div className="flex flex-col">
                    <span className="text-[#8C8C8C] text-[11px]">Joined Date</span>
                    <span className="truncate">
                      {separateDateTimeAndConvertToLocale(fundraiser?.createdAt)?.localDate || "N/A"}
                    </span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[#8C8C8C] text-[11px]">Contact</span>
                    <span className="truncate">{fundraiser?.contactPersonNumber || "N/A"}</span>
                  </div>
                  <div className="flex flex-col col-span-2 mt-1">
                    <span className="text-[#8C8C8C] text-[11px]">Balance</span>
                    <span className="truncate font-[600] text-[#00ADEF]">
                      {"$" + (fundraiser?.balance || "0")}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-2 mt-2">
                  <button
                    className="flex-1 flex justify-center items-center border border-[#00ADEF] rounded-[6px] py-2 bg-[#F0FBFF] hover:bg-[#E0F7FA] transition-colors"
                    onClick={() => openPopup(fundraiser?._id)}
                  >
                    <span className="font-[600] text-[13px] text-[#00ADEF] font-poppins">
                      View Details
                    </span>
                  </button>
                </div>
              </div>
            ))
          }
          {!loading && !searching && (!displayedFundraisers || displayedFundraisers.length === 0) && (
            <TableEmptyState itemName="Fundraiser" />
          )}
        </div>

        {displayedFundraisers && displayedFundraisers.length > 0 && (
          <Pagination
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        )}

        {/* Action Modal */}
        {showActionModal && (
          <div
            className="fixed bottom-16 left-[57%] transform -translate-x-1/2 bg-white rounded-[6px] px-4 h-[60px] flex items-center gap-4 z-50 text-[14px] font-[600] text-[#303030] border border-[#0000001A]"
            style={{ boxShadow: "0px 4px 20px 0px #00000029" }}
          >
            <div className="flex items-center gap-2">
              <span className="!text-[12px] !font-[500] !text-[#000000] border border-[#2A35484D] rounded-[4px] w-[24px] h-[24px] flex items-center justify-center">
                {selected.length}
              </span>
              <span className="!font-[500]">Selected</span>
            </div>
            <div className="flex items-center gap-16">
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <Checkbox
                    checked={allSelectableSelected}
                    onChecked={handleSelectAll}
                    divClassName="flex items-center"
                    UncheckedIcon={UncheckedGreyIcon}
                    checkClassName={"!w-[22px] !h-[22px]"}
                  />
                  <span className="whitespace-nowrap !font-[500]">
                    Select All
                  </span>
                </div>
                {showApproveDecline && (
                  <>
                    <button
                      onClick={handleBulkApprove}
                      className={`bg-[#00ADEF] text-white h-[38px] whitespace-nowrap pl-4 pr-8 py-1 rounded-[6px] flex items-center gap-2 ${selected.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                      disabled={selected.length === 0}
                    >
                      <img
                        src={whiteTick}
                        alt="tick"
                        className="h-[16px] w-[16px]"
                      />
                      {selected.length > 1 ? 'Approve Fundraisers' : 'Approve Fundraiser'}
                    </button>
                    <button
                      onClick={handleBulkDecline}
                      className={`border border-[#00ADEF] text-[#00ADEF] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap ${selected.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                      disabled={selected.length === 0}
                    >
                      {selected.length > 1 ? 'Decline Fundraisers' : 'Decline Fundraiser'}
                    </button>
                  </>
                )}
                {showMoveToPending && (
                  <button
                    onClick={handleBulkPending}
                    className="border border-[#00ADEF] text-[#00ADEF] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap"
                  >
                    Move to Pending
                  </button>
                )}
              </div>
              <button
                onClick={() => setSelected([])}
                className="w-[10px] h-[10px]"
              >
                <img src={closeIcon} alt="Close" className="w-full h-full" />
              </button>
            </div>
          </div>
        )}

        {/* Review Status Modal */}
        {showReviewModal && (
          <div className="popup-container" style={{ zIndex: 9999 }}>
            <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4 shadow-xl border border-[#00ADEF]">
              <h3 className="text-lg font-semibold mb-4 text-center">Review Status</h3>
              <p className="text-gray-600 mb-6 text-center">
                Are you sure you want to change the status from{" "}
                <span className="font-semibold capitalize">{fundraiserDetails?.status}</span> to{" "}
                <span className="font-semibold">Pending</span>?
              </p>
              <div className="flex gap-3">
                <button
                  onClick={handleCloseReviewModal}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleReviewStatus(fundraiserDetails?._id, "pending")}
                  className="flex-1 px-4 py-2 bg-[#00ADEF] text-white rounded-md hover:bg-[#0088CC]"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}

        {showBulkDeclineModal && (
          <RejectOfferPopup
            handleClose={closeBulkDeclineModal}
            content={"Please provide a reason for declining the selected fundraiser(s)."}
            popupClassName={"w-[335px] sm:w-[470px] pb-4"}
            setReason={setBulkDeclineReason}
            handleOfferRejection={submitBulkDecline}
            showCloseIcon={true}
          />
        )}
      </div>
    </>
  );
};

export default FundraiserListDataTable;
